import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { frappePost } from '@/lib/frappe';

export const reviewKeys = {
  all: ['reviews'] as const,
  teacher: (teacher: string, page?: number) => [...reviewKeys.all, 'teacher', teacher, page] as const,
  myReviews: () => [...reviewKeys.all, 'my'] as const,
};

export function useTeacherReviews(teacher: string, page: number = 0, pageSize: number = 10) {
  return useQuery({
    queryKey: reviewKeys.teacher(teacher, page),
    queryFn: () =>
      frappePost<{
        reviews: Array<{
          name: string;
          student_name: string;
          student_image?: string;
          rating: number;
          comment?: string;
          comment_ar?: string;
          teacher_response?: string;
          teacher_response_ar?: string;
          creation: string;
        }>;
        total: number;
        average_rating: number;
        rating_distribution: Record<string, number>;
      }>(
        'hudan_lms.hudan_lms.doctype.hudan_review.hudan_review.get_teacher_reviews',
        { teacher, page, page_size: pageSize },
        false
      ),
    enabled: !!teacher,
  });
}

export function useSubmitTeacherResponse() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { review_name: string; response: string; response_ar?: string }) =>
      frappePost<{ success: boolean }>(
        'hudan_lms.hudan_lms.doctype.hudan_review.hudan_review.submit_teacher_response',
        data
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: reviewKeys.all });
    },
  });
}
